import { lawconnect } from '../../api/lawconnect';
import { BrowserFourdApi } from '.';

export class LawConnect implements lawconnect.Api {
  constructor(private fourd: BrowserFourdApi) {}

  shareDocuments(request: lawconnect.ShareDocumentsRequest): void {
    this.fourd.call4Dv2('lawconnect.shareDocuments', request);
  }

  shareFolder(request: lawconnect.ShareFolderRequest): void {
    this.fourd.call4Dv2('lawconnect.shareFolder', request);
  }

  shareOfficeStatement(request: lawconnect.ShareOfficeStatementRequest): void {
    this.fourd.call4Dv2('lawconnect.shareOfficeStatement', request);
  }

  shareTrustStatement(request: lawconnect.ShareTrustStatementRequest): void {
    this.fourd.call4Dv2('lawconnect.shareTrustStatement', request);
  }
}
